import classNames from 'classnames';
import React, { Suspense } from 'react';
// import { configResponsive, useResponsive } from 'ahooks';
import Loading from '../loading';
import BasicLayout, { BasicLayoutHeader } from './basic-layout';
import DashboardLayout from './dashboard-layout';
import FixbarLayout, { FixbarLayoutBody } from './fixbar-layout';
import Footer from './footer';
import GlobalDrawer from './globalDrawer';
import { useGlobalDrawer } from './globalDrawer/event';
import ListLayout, { ListLayoutBody } from './list-layout';
import CreateLayout from './create-layout';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
{
  /*
   页面分成左右两部分，分别是左边菜单和右边内容
  滚动范围：内容除去header部分（包括footer）
  自适应：
  内容：页面最小宽度为1032px，内容最小为1032 - 64 = 968px，大于968px时100%平铺
  菜单：
  1.页面在1032-1208px之间（不包括1280px）时，主子菜单均收起，展开时不挤压内容区域
  2.页面在1208px-1440px之间（包括1208px，1440px）时，主菜单收起，子菜单不收起
  3.大于1440px(不包括1440px)时，主菜单展开，子菜单展开
  */
}

// configResponsive({
//   s: 0, //1032
//   m: 1208,
//   l: 1440 + 1,
// });

const Layout = props => {
  const {
    header,
    subHeader,
    sidebar,
    footer,
    children,
    contentExtra,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style
  } = props;
  const baseClassName = "".concat(prefixClass, "-layout");

  // const responsive = useResponsive();

  // const sidebar_responsive = useMemo(() => {
  //   let _r;
  //   Object.keys(responsive).forEach((key) => {
  //     if (responsive[key]) {
  //       _r = key;
  //     }
  //   });
  //   return _r;
  // }, [responsive]);
  return /*#__PURE__*/_jsxs("div", {
    className: classNames(baseClassName, className),
    style: style,
    children: [/*#__PURE__*/React.isValidElement(sidebar) && /*#__PURE__*/React.cloneElement(sidebar, {
      className: "".concat(baseClassName, "-sidebar")
      // responsive: sidebar.props.responsive || sidebar_responsive,
    }), /*#__PURE__*/_jsxs("div", {
      className: "".concat(baseClassName, "-content"),
      children: [/*#__PURE__*/React.isValidElement(header) && /*#__PURE__*/React.cloneElement(header, {
        className: "".concat(baseClassName, "-header")
      }), /*#__PURE__*/React.isValidElement(subHeader) && /*#__PURE__*/React.cloneElement(subHeader, {
        className: "".concat(baseClassName, "-subHeader")
      }), /*#__PURE__*/_jsx(Suspense, {
        fallback: /*#__PURE__*/_jsx(Loading.Page, {}),
        children: /*#__PURE__*/_jsxs("div", {
          className: "".concat(baseClassName, "-main"),
          id: "popupContainer",
          children: [/*#__PURE__*/_jsx("div", {
            className: "".concat(baseClassName, "-route"),
            children: children
          }), footer || /*#__PURE__*/_jsx(Footer, {
            prefixClass: prefixClass
          })]
        })
      }), /*#__PURE__*/_jsx(GlobalDrawer, {
        className: classNames({
          hasHeader: /*#__PURE__*/React.isValidElement(header)
        })
      }), /*#__PURE__*/React.isValidElement(contentExtra) && /*#__PURE__*/React.cloneElement(contentExtra)]
    })]
  });
};
Layout.useGlobalDrawer = useGlobalDrawer;
Layout.BasicLayoutHeader = BasicLayoutHeader;
Layout.BasicLayout = BasicLayout;
Layout.DashboardLayout = DashboardLayout;
Layout.ListLayoutBody = ListLayoutBody;
Layout.ListLayout = ListLayout;
Layout.FixbarLayout = FixbarLayout;
Layout.FixbarLayoutBody = FixbarLayoutBody;
Layout.CreateLayout = CreateLayout;
Layout.Footer = Footer;
export default Layout;